import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'  // import your Vuex store instance

import Home from '@/components/home/Index'
import Login from '@/components/main/Login'
import MobileApps from '@/components/mobileapps/main/Index'
import Users from '@/components/users/users/Index'
// import StoreRequest from '@/components/store/main/StoreRequest'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {path: '/', name: 'Home', component: Home, meta: {forAuth: false}},
    {path: '/login', name: 'Login', component: Login, meta: {forAuth: false}},
    {path: '/mobileapps', name: 'MobileApps', component: MobileApps, meta: {forAuth: false}},
    {path: '/users', name: 'Users', component: Users, meta: {forAuth: true}},
    // {path: '/storerequest', name: 'StoreRequest', component: StoreRequest, meta: {forAuth: true}},
  ]
})

// Add navigation guard on the router instance
router.beforeEach((to, from, next) => {
  if (to.meta.forAuth) {
    if (to.path === '/users') {
      // const perms = store.getters.userPermissions || []
      // console.log("stif|perms:", perms)
      store.dispatch('userPermissions', "User Management")
        .then(permissions => {
          // permissions is the resolved data from the API call
          // console.log('User permissions:', permissions);
          if (permissions.includes('View Users') && permissions.includes('View Roles')) {
            next()
          } else {
            next({ path: '/' })  // redirect if permissions missing
          }
        })
        .catch(error => {
          console.error('Failed to load permissions:', error);
          next({ path: '/' })
        });
      next()
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js